export enum CatalogItemType {
  DRUG = "drug",
  PRODUCT = "product"
}

export interface CatalogItem {
  id: string;
  catalogId: string;
  name: string;
  type: CatalogItemType;
  minsan?: string;
  gtin?: string;
  vat?: number;
  retailPrice?: number;
  pieces?: number;
}
